{
    "actions": {
        "page": {
            "add_organization": "New organization",
            "add_direct_organization": "New direct organization",
            "update_organization": "Update organization",
            "update_subdomain": "Update subdmain",
            "update_brand": "Update organization brand",
            "add_existing_plan": "Add an existing plan",
            "update_type": "Update type",
            "add_user": "New monetic user",
            "update_sim_offers": "Update SIM offers"
        }
    },
    "details": {
        "connection_points": {
            "port_type": {
                "SIMPLEAUTH": "SSL profile: SIMPLEAUTH (STCA)",
                "STCA_INGET": "SSL profile: STCA_INGET"
            },
            "public_ip": {
                "custom_site": "{{ip}} - {{site}}",
                "site": "{{ip}} - Site {{site}}",
                "no_site": "{{ip}}"
            },
            "port": {
                "redirected": "{{port}} - Redirected port (SSLv3, TLSv1.0, TLSv1.1, TLSv1.2)",
                "tlsv1_2": "{{port}}  - TLSv1.2"
            }
        },
        "legal_infos": {
            "title": "Legal informations",
            "disclaimer": "The following information is extracted from the official database containing legal identification information of french companies."
        },
        "alerts": {
            "add_emails": "Add emails",
            "configure_alerts": "Setting up alerts",
            "delete_mail": "Delete this email",
            "new_pos_connections": {
                "title": "New POS connections"
            },
            "not_set": "No email alert set",
            "consumption": {
                "title": "SIM cards consumption",
                "sim_cards": {
                    "title": "SIM cards",
                    "configured": "SIM group alerts configured with a threshold of {{threshold}}%",
                    "non_configured": "No SIM group alert configured"
                },
                "sim_groups": {
                    "title": "SIM groups",
                    "configured": "SIM group alerts configured with a threshold of {{threshold}}%",
                    "non_configured": "No SIM group alert configured"
                },
                "receivers_one": "Receiver of alerts",
                "receivers_other": "Receivers of alerts"
            }
        },
        "sim_offers": {
            "sierra_wireless": {
                "name": "Sierra Wireless",
                "manage": "SIM offers management (Sierra Wireless)"
            },
            "deutsche_telekom": {
                "name": "Deutsche Telekom",
                "manage": "SIM offers management (Deutsche Telekom)"
            },
            "service": {
                "name": "SIM service",
                "manage": "SIM offers management (SIM service)"
            },
            "bouygues_telecom": {
                "name": "Bouygues Telecom",
                "manage": "SIM offers management (Bouygues Telecom)"
            }
        }
    },
    "keys": {
        "registration_number": "Registration number",
        "legal_name": "Organization name",
        "business_name": "Business name",
        "type": "Organization type",
        "created_at": "Created on",
        "updated_at": "Last updated on",
        "ports": "Ports",
        "comment": "Comment",
        "client_code": "Client code",
        "billing_id_read": "Billing ID",
        "billable": "Billable",
        "push_payments_legal_name": "Push Payment partner(s)",
        "head_office_registration_number": "Head office registration number",
        "branch_business_sector_label": "Branch business sector",
        "company_long_name": "Company long name",
        "legal_nature_label": "Legal nature",
        "legal_address": "Address",
        "creation_date": "Creation date",
        "update_date": "Data update date",
        "brand_domain_name": "Domain name",
        "main_color": "Main color",
        "brand_logo": "Logo",
        "connection_point_ip_address": "IP Address",
        "connection_point_port": "Port",
        "no_legal_info": "No legal information found",
        "more_legal_info": "More informations from"
    },
    "filter": {
        "placeholder": {
            "legal_name": "Filter by organization name",
            "registration_number": "Filter by registration number",
            "business_name": "Filter by business name"
        }
    },
    "form": {
        "error": {
            "INVALID_REGISTRATION_NUMBER": "Please enter a valid registration number"
        }
    },
    "modal": {
        "update_subdomain": {
            "title": "Update subdomain",
            "success": "Subdomain successfully updated!",
            "error": {
                "default": "An error occurred while updating subdomain",
                "already_used": "The subdomain already exists"
            }
        },
        "add_organization": {
            "title": "New organization",
            "info": "No information found for the given registration number",
            "registration_number": "Registration number",
            "success": "L'organisation a été ajoutée avec succès !",
            "steps": {
                "registration_number": "Step {{step}} of {{maxStep}}: Enter registration number",
                "organization_info": "Step {{step}} of {{maxStep}}: Enter organization infos"
            }
        },
        "update_organization": {
            "title": "Update organization",
            "billable_options": {
                "true": "Yes",
                "false": "No"
            },
            "success": "Organization successfully updated!",
            "error": {
                "default": "An error occurred while updating organization"
            }
        },
        "update_brand": {
            "title": "Update organization brand",
            "success": "Organization brand successfully updated!",
            "error": {
                "default": "An error occurred while updating organization brand"
            },
            "logo": {
                "info1": "Specifications:",
                "info2": "Accepted formats: PNG, JPG, JPEG",
                "info3": "Maximum size: 200 KB",
                "upload": "Upload logo",
                "delete": "Delete logo",
                "error": "The file is too large or the format is not supported"
            },
            "color": {
                "error": "Required field: Color"
            }
        },
        "delete_mail": {
            "title": "Delete an email",
            "message": "The email {{email}} will be deleted and will not receive alerts anymore.",
            "confirm": "Do you want to continue?",
            "success": "Email successfully deleted!"
        },
        "add_emails": {
            "title_new_pos": "New POS connections alerts",
            "title_consumption": "SIM card consumption alerts",
            "message": "You can still create {{emailsNumber}} email alert.",
            "confirm": "This email will receive alerts:",
            "blocked": "Please configure an alert before adding emails",
            "max_emails_number_reached": "You cannot create more email alerts\n(maximum number of {{emailsNumber}} emails reached)",
            "success": "Email(s) successfully added!"
        },
        "configure": {
            "title": "Edit alerts",
            "threshold": "Alert threshold",
            "success": "Alerts are successfully configured!",
            "sim_cards": {
                "title": "SIM cards",
                "message": "Send an alert to SIMs whose monthly consumption exceeds the threshold."
            },
            "sim_groups": {
                "title": "SIM groups",
                "message": "Send an alert to SIM groups whose monthly consumption exceeds the threshold."
            }
        },
        "update_organization_type": {
            "title": "Update type",
            "success": "Organization successfully transformed in White Label! Please add the port.",
            "error": {
                "default": "An error occurred while transforming organization",
                "already_used": "The subdomain already exists"
            }
        },
        "update_sim_offers": {
            "title": "Update SIM offers",
            "subtitle": "SIM offers",
            "show_all": "Show all",
            "no_data": "You currently do not have any SIM plan associated with your organization.",
            "success": "Offer updated successfully!",
            "error": "An error occurred while updating SIM plans"
        },
        "errors": {
            "UNKNOWN_ERROR": "An unknown error occurred.",
            "ORGANIZATION_ALREADY_EXISTS": "Une organisation avec ce nom existe déjà"
        }
    },
    "type": {
        "WHITE_LABEL": "White label",
        "MERCHANT": "Merchant"
    }
}